export default __webpack_public_path__ + "static/5905v5907-b1bc66613ad7fe77b8be6fef51fdf0b5.png";